import { default as companysTypes } from "./types";

const {
  ADD_COMPANY_REQUEST,
  ADD_COMPANY_SUCCESS,
  ADD_COMPANY_FAILURE,
  FETCH_COMPANYS_REQUEST,
  FETCH_COMPANYS_SUCCESS,
  FETCH_COMPANYS_FAILURE,
} = companysTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COMPANY_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: "",
      };
    case ADD_COMPANY_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    case FETCH_COMPANYS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_COMPANYS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_COMPANYS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
